'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = VegetarianSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VegetarianSvg(props) {
    var size = props.size,
        secondaryColor = props.secondaryColor,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'bgimgVeg', width: size, height: size, viewBox: '0 0 28 28', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-full-bg-vegetarian' },
        _react2.default.createElement(
            'title',
            { id: 'bgimgVeg' },
            i18n.get('openrest_menubuilderv3_dishlabels_vegetarian') || 'vegetarian'
        ),
        _react2.default.createElement(
            'g',
            { fill: 'none' },
            _react2.default.createElement('path', {
                d: 'M13.6501-.0004c-7.527 0-13.65 6.123-13.65 13.65 0 7.526 6.123 13.65 13.65 13.65s13.651-6.124 13.651-13.65c0-7.527-6.124-13.65-13.651-13.65z',
                fill: primaryColor }),
            _react2.default.createElement('path', {
                d: 'M21.7344 13.4638l.003.003c.134.142.202.314.202.512v3.017c0 .269-.122.483-.361.633-.412.27-.875.482-1.372.63-.494.149-1.012.226-1.538.226-.905 0-1.746-.221-2.501-.655-.754-.433-1.358-1.033-1.793-1.779-.434-.746-.654-1.579-.654-2.475 0-.896.22-1.728.654-2.473.435-.746 1.039-1.345 1.793-1.779.756-.434 1.596-.654 2.501-.654.451 0 .892.049 1.311.149.419.098.805.25 1.145.453.117.067.207.153.268.255.061.103.091.212.091.336 0 .197-.07.375-.203.517-.269.29-.656.258-.906.104-.541-.248-1.12-.379-1.706-.379-.627 0-1.206.154-1.721.458-.518.304-.933.727-1.233 1.257-.3.53-.452 1.121-.452 1.756 0 .636.153 1.224.452 1.75.3.525.714.95 1.232 1.258.759.453 1.655.573 2.663.359.308-.066.577-.151.801-.253v-1.999h-1.542c-.199 0-.372-.07-.512-.205-.14-.135-.212-.306-.212-.507 0-.211.072-.386.212-.521.141-.135.314-.204.512-.204h2.36c.198 0 .368.071.506.21zm-9.3643-4.5522c.272-.188.646-.16.905.073.148.134.222.298.222.489 0 .104-.026.215-.076.33l-3.414 8.075c-.073.157-.175.274-.307.352-.119.076-.256.119-.383.12-.153-.011-.273-.052-.39-.128-.112-.073-.205-.18-.271-.309l-3.432-8.124c-.043-.086-.054-.213-.054-.302 0-.212.076-.386.226-.516.155-.132.317-.195.498-.195.207 0 .492.082.664.473l2.846 6.727 2.684-6.72c.074-.153.165-.263.282-.345z',
                fill: secondaryColor })
        )
    );
}

VegetarianSvg.displayName = 'VegetarianSvg';
VegetarianSvg.propTypes = {
    size: _propTypes2.default.number,
    secondaryColor: _propTypes2.default.string,
    primaryColor: _propTypes2.default.string
};
VegetarianSvg.defaultProps = {
    size: 28,
    secondaryColor: '#fff',
    primaryColor: '#a9c360'
};